'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _HeaderLayout = require('./HeaderLayout.scss');

var _HeaderLayout2 = _interopRequireDefault(_HeaderLayout);

var _X = require('../svg/X.js');

var _X2 = _interopRequireDefault(_X);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderLayout = function HeaderLayout(_ref) {
  var title = _ref.title,
      onCancel = _ref.onCancel,
      theme = _ref.theme,
      closeButton = _ref.closeButton;


  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_HeaderLayout2.default.header, _HeaderLayout2.default[theme]), 'data-hook': 'header-layout' },
    _react2.default.createElement(
      'span',
      { className: _HeaderLayout2.default.titleLabel, 'data-hook': 'header-layout-title' },
      title
    ),
    closeButton && _react2.default.createElement(
      'button',
      { type: 'button', className: _HeaderLayout2.default.close, 'data-hook': 'header-close-button', onClick: onCancel },
      _react2.default.createElement(_X2.default, { width: 9, height: 9, thickness: 1, color: 'white' })
    )
  );
};

HeaderLayout.defaultProps = {
  theme: 'blue',
  closeButton: true
};

HeaderLayout.propTypes = {
  title: _propTypes2.default.node,
  onCancel: _propTypes2.default.func,
  closeButton: _propTypes2.default.bool,
  theme: _propTypes2.default.oneOf(['red', 'green', 'blue', 'lightGreen'])
};

exports.default = HeaderLayout;